import "../../App.css";
import "../../styles/tabStyle.css";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import AutocompleteForms from "../AutocompleteForms";
import React, { useState, useEffect } from "react";
import Parametros from "../Parametros";
import Modal from "react-modal";
import CurrentUser from "../CurrentUser";

function PersonaEmpresa(props) {
  // eslint-disable-next-line
  const [PersonaEmpresaState, setPersonaEmpresaState] = useState([]);
  // eslint-disable-next-line
  const [PersonaEmpresaStateUpdate, setPersonaEmpresaStateUpdate] = useState(
    []
  );

  const [update, setUpdate] = useState(false);
  const [formularioState, setFormularioState] = useState({});
  //
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [countries, setCountries] = useState([]);
  // const [formularioUpdate, setformularioUpdate] = useState({})

  useEffect(() => {
    setFormularioState({
      legal_id: "",
      verif_legal_id: "",
      legal_type: props.legal_type,
      full_name: "",
      first_name: "",
      last_name_1: "",
      last_name_2: "",
      country_id: "",
    });
    fetch(Parametros.urlApi + "Countries?skip=0&limit=100", {
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setCountries(data);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.legal_type, update]);

  let handleStageForm = (event) => {
    event.preventDefault();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;

    setFormularioState({
      ...formularioState,
      [event.target.name]: value,
    });
  };

  let crearEmpresa = async (event) => {
    event.preventDefault();

    if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
      // aqui deberia ir el delete segun response eliminar de la lista de react

      let newform = formularioState;

      countries.map((item) => {
        if (item.alias === newform.country_id) {
          newform.country_id = item.country_id;
        }
        return item;
      });

      let response = await fetch(Parametros.post + "person", {
        method: "POST",
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
        },
        body: JSON.stringify(newform),
      });

      let responseJson = await response.json();

      if (response.status === 200 || response.status === 201) {
        alert("Se agrego correctamente");
        setUpdate(!update);
        document.getElementById("formularioBusqueda").reset();
        props.modalCondig();
      } else {
        alert(responseJson.detai);
      }
    } else {
      // Do nothing!
      setPersonaEmpresaState(
        JSON.parse(JSON.stringify(PersonaEmpresaStateUpdate))
      );
    }
  };

  const customStyles = {
    overlay: {
      zIndex: "4",
    },
    content: {
      top: "50%",
      left: "50%",
      right: "50%",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  return (
    <>
      <>
        <Modal
          isOpen={props.modalState}
          contentLabel="Example Modal"
          ariaHideApp={false}
          style={customStyles}
          onRequestClose={props.modalCondig}
        >
          <form id="formularioBusqueda" onSubmit={crearEmpresa}>
            <div className="col-md-4">
              <h5>Pais</h5>
              <AutocompleteForms
                nameElement={"country_id"}
                formularioBuscado={formularioState}
                setformulario={setFormularioState}
                required={true}
                value={formularioState.country_id}
                key={update}
                personalHandleChange={handleStageForm}
                suggestions={countries.map((item) => {
                  return { ...item, value: item.country_id, label: item.alias };
                })}
              />
            </div>

            {formularioState.legal_type === "N" && (
              <>
                <div className="col-md-4">
                  <h5>Nombres</h5>
                  <input
                    onChange={handleStageForm}
                    name="first_name"
                    required
                    className="form-control"
                  ></input>
                </div>

                <div className="col-md-4">
                  <h5>Apellido paterno</h5>
                  <input
                    onChange={handleStageForm}
                    name="last_name_1"
                    required
                    className="form-control"
                  ></input>
                </div>

                <div className="col-md-4">
                  <h5>Apellido materno</h5>
                  <input
                    onChange={handleStageForm}
                    name="last_name_2"
                    required
                    className="form-control"
                  ></input>
                </div>
              </>
            )}
            {formularioState.legal_type === "J" && (
              <>
                <div className="col-md-4">
                  <h5>Empresa</h5>
                  <input
                    onChange={handleStageForm}
                    name="full_name"
                    required
                    className="form-control"
                  ></input>
                </div>
              </>
            )}

            <div className="col-md-4">
              <h5>Rut</h5>
              <input
                onChange={handleStageForm}
                name="legal_id"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-4">
              <h5>Digito Verificador</h5>
              <input
                onChange={handleStageForm}
                name="verif_legal_id"
                required
                className="form-control"
              ></input>
            </div>

            <div className="col-md-3">
              <br />
              <button
                type="submit"
                value="Submit"
                style={{ margin: "14px 0px" }}
                id="btnBuscar"
                className="form-control button brEdit btn-primary"
              >
                Agregar
              </button>
            </div>
          </form>
        </Modal>
      </>
    </>
  );
}

export default withRouter(PersonaEmpresa);
